import { CourseDurationPricing } from '@shared/types';
import classNames from 'classnames';
import { FunctionComponent } from 'react';
import styles from './styles.module.css';
import { RadioGroup } from '../../../../../RadioGroup';

export type DurationSelectorProps = {
    durationPricing: CourseDurationPricing[];
    value: CourseDurationPricing;
    onChange: (newPricing: CourseDurationPricing) => any;
};

const getDurationLabel = (durationInMinutes: number): string => {
    if (durationInMinutes === 0) {
        return '';
    }
    if (durationInMinutes <= 1) {
        return `1 Minute`;
    }
    if (durationInMinutes < 60) {
        return `${durationInMinutes} Minutes`;
    }
    if (durationInMinutes === 60) {
        return '1 Hour';
    }
    if (durationInMinutes < 60 * 24) {
        const hours = durationInMinutes / 60;
        const remaining = durationInMinutes % 60;
        return `${hours} Hours ${getDurationLabel(remaining)}`;
    }
    if (durationInMinutes === 60 * 24) {
        return '1 Day';
    }
    const days = durationInMinutes / (60 * 24);
    const remaining = durationInMinutes % (60 * 24);
    return `${days} Days ${getDurationLabel(remaining)}`;
};

export const DurationSelector: FunctionComponent<DurationSelectorProps> = ({
    durationPricing,
    value,
    onChange,
}) => {
    if (durationPricing.length === 1) {
        return null;
    }
    return (
        <div className={styles.container}>
            <h2>Preferred Duration</h2>
            <RadioGroup options={durationPricing} value={value} onChange={onChange}>
                {(durationPricing, isChecked, isFocussed) => {
                    return (
                        <div
                            className={classNames(styles.option, {
                                [styles.checked]: isChecked,
                                [styles.focussed]: isFocussed,
                            })}
                        >
                            <input type="radio" checked={isChecked} />
                            <div className={styles.label}>
                                <span className={styles.duration}>
                                    {getDurationLabel(durationPricing.duration)}
                                </span>
                                <span>{durationPricing.label}</span>
                                <div className={styles.description}>
                                    {durationPricing.description}
                                </div>
                            </div>
                            <div className={styles.cost}>
                                {durationPricing.extra_cost
                                    ? `+ £${durationPricing.extra_cost}`
                                    : null}
                            </div>
                        </div>
                    );
                }}
            </RadioGroup>
        </div>
    );
};
